import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    search: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'project-tag/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_PROJECT_TAGS_REQUEST,
                        types.SEARCH_PROJECT_TAGS_SUCCESS,
                        types.SEARCH_PROJECT_TAGS_FAILURE
                    ]
                }
            });
        },
    saveProjectTag: (projectTag) =>
    (dispatch) => {
        if (projectTag.id === 0) {
            // Create
            return dispatch({
                [CALL_API]: {
                    endpoint: 'project-tag/create',
                    method: 'POST',
                    body: projectTag,
                    types: [
                        types.CREATE_PROJECT_TAG_REQUEST,
                        types.CREATE_PROJECT_TAG_SUCCESS,
                        types.CREATE_PROJECT_TAG_FAILURE
                    ]
                }
            });
        } else {
            // Update
            return dispatch({
                [CALL_API]: {
                    endpoint: 'project-tag/update',
                    method: 'PUT',
                    body: projectTag,
                    types: [
                        types.UPDATE_PROJECT_TAG_REQUEST,
                        types.UPDATE_PROJECT_TAG_SUCCESS,
                        types.UPDATE_PROJECT_TAG_FAILURE
                    ]
                }
            });
        }
    }
}